export type SportCourtTypesProps = {
  hasBasketball: boolean;
  hasBocce: boolean;
  hasMultiPurpose: boolean;
  hasOther: boolean;
  hasRacquetball: boolean;
  hasShuffleboard: boolean;
  hasSportsField: boolean;
  hasTennis: boolean;
  hasVolleyball: boolean;
};

const SportCourtTypes = ({
  hasBasketball = false,
  hasBocce = false,
  hasMultiPurpose = false,
  hasOther = false,
  hasRacquetball = false,
  hasShuffleboard = false,
  hasSportsField = false,
  hasTennis = false,
  hasVolleyball = false,
}: Partial<SportCourtTypesProps> = {}): SportCourtTypesProps => ({
  hasBasketball: Boolean(hasBasketball),
  hasBocce: Boolean(hasBocce),
  hasMultiPurpose: Boolean(hasMultiPurpose),
  hasOther: Boolean(hasOther),
  hasRacquetball: Boolean(hasRacquetball),
  hasShuffleboard: Boolean(hasShuffleboard),
  hasSportsField: Boolean(hasSportsField),
  hasTennis: Boolean(hasTennis),
  hasVolleyball: Boolean(hasVolleyball),
});

export default SportCourtTypes;
